<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country active" :to="localePath('/wine-guide/usa/napa/abreu-vineyards')">Abreu Vineyards</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/usa/napa/caymus-vineyards')">Caymus vineyards</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/usa/napa/christian-moueix-dominus')">Christian Moueix - Dominus</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/usa/napa/colgin-cellars')">Colgin Cellars</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/usa/napa/harlan-estates')">Harlan Estates</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/usa/napa/kapcsandy-winery')">Kapcsandy Winery</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/usa/napa/opus-one')">Opus One</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/usa/napa/robert-mondovi-vineyards')">Robert Mondovi Vineyards</nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/scarecrow-wines')">Scarecrow Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/schrader-cellars')">Schrader Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/screaming-eagle')">Screaming Eagle
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">I vigneti di Abreu</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Contrariamente ai vigneti europei, gli Stati Uniti non detengono la stessa storia viticola familiare
                        altri paesi (ti stiamo guardando Francia). Ergo, se hai i soldi, le conoscenze e
                        soprattutto, l'ambizione di creare da zero un Cabernet Sauvignon superlativo, nessuno
                        sta per fermarti. Quindi David Abreu è una specie di rarità nelle aziende vinicole della Napa Valley. Il terzo
                        generazione per gestire la tenuta della sua famiglia, David ha un pedigree di vinificazione che farebbe anche
                        IL ????? Di ???? prendi nota.
                    </div>

                    <div class="howto-title2">Madre Madrona</div>
                    <div class="howto-text">
                        Guadagnandosi le strisce in quasi tutti i vigneti più famosi della California (incluso Screaming
                        Eagle), David ha iniziato la sua carriera gestendo i campi (come suo padre e suo nonno prima
                        lui). Tuttavia, la passione di David che un giorno avrebbe creato la sua etichetta è diventata troppo forte, quindi dentro
                        1986 ha acquistato il (ora famoso) Vigneto Madrona di 23 acri. Madrona era stata piantata da sei anni
                        in precedenza, ma il terreno povero richiedeva una conoscenza del terroir superiore che solo Abreu poteva fare
                        fornire. Il 1987 ha visto la sua prima uscita commerciale, una miscela di varietà bordolesi tra cui il Cabernet
                        Sauvignon, Cabernet Franc e Merlot (da allora Abreu ha piantato e aggiunto Petit Verdot alla
                        mescolare). Seguirono recensioni entusiastiche e passaparola positivi e nel 1994 Madrona di Abreu ebbe un enorme culto
                        seguente. È interessante notare che quasi tutto il personale originale (incluso l'enologo
                        Brad Grimes) stanno ancora lavorando con Abreu, e forse uno degli elementi chiave del suo successo.
                    </div>

                    <div class="howto-title2">Un potente Napa</div>
                    <div class="howto-text">
                        La reputazione di David come viticoltore costantemente concentrato e meticoloso lo precede e come
                        così, i suoi Thorevilos e Madrona Ranch sono alcuni dei vini più ricercati della Napa
                        Valle. Il suo approccio semplice e di buon senso è rinfrescante, e questo ha il sapore di
                        il suo (sorprendentemente complesso) vino. Naturalmente, tale raffinatezza ha un prezzo; a partire dal terzo trimestre 2019,
                        il suo Madrona da 100 punti 2013 (capacità di invecchiamento di 50 anni) è stato valutato intorno ai 700 euro, uno dei
                        Le migliori e più sicure opzioni di investimento di Napa.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Abreu Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Im Gegensatz zu europäischen Weinbergen hat die Weinbaugeschichte der Familie in den USA nicht so viel zu bieten wie
                        andere Länder (wir meinen Sie Frankreich). Ergo, wenn Sie das Geld, das Wissen und
                        Am wichtigsten ist, dass niemand den Ehrgeiz hat, einen Cabernet Sauvignon der Superlative von Grund auf zu kreieren
                        wird dich aufhalten. Daher ist David Abreu in den Weingütern des Napa Valley eine Seltenheit. Der dritte
                        Da David seit einer Generation das Weingut seiner Familie bewirtschaftet, verfügt er über einen Winzer-Stammbaum, der dies ausgleichen würde
                        Die ????? von ???? beachten.
                    </div>

                    <div class="howto-title2">Mutter Madrona</div>
                    <div class="howto-text">
                        Er verdiente sich seine Sporen in fast allen renommiertesten Weingütern Kaliforniens (einschließlich Screaming
                        Eagle) begann David seine Karriere als Feldverwalter (wie zuvor sein Vater und sein Großvater).
                        ihn). Doch Davids Leidenschaft, eines Tages sein eigenes Label zu gründen, wurde zu groß, und so ging es weiter
                        1986 kaufte er das (heute berühmte) 23 Hektar große Madrona Vineyard. Madrona war sechs Jahre lang gepflanzt worden
                        zuvor, aber der karge Boden erforderte überlegene Terroirkenntnisse, die nur Abreu konnte
                        bieten. 1987 erschien seine erste kommerzielle Veröffentlichung, eine Mischung aus Bordeaux-Rebsorten, darunter Cabernet
                        Sauvignon, Cabernet Franc und Merlot (Abreu hat inzwischen Petit Verdot gepflanzt und hinzugefügt
                        mischen). Es folgten begeisterte Kritiken und positive Mundpropaganda, und 1994 hatte Abreus Madrona großen Kult
                        folgende. Es ist interessant festzustellen, dass fast das gesamte ursprüngliche Personal (einschließlich Winzer)
                        Brad Grimes) arbeiten immer noch mit Abreu zusammen und sind möglicherweise einer der Schlüsselfaktoren für seinen Erfolg.
                    </div>

                    <div class="howto-title2">Ein Power-Napa</div>
                    <div class="howto-text">
                        Davids Ruf als stets fokussierter, akribischer Weinbauer eilt ihm voraus
                        So gehören seine Thorevilos und Madrona Ranch zu den gefragtesten Weinen in Napa
                        Schlucht. Sein einfacher, vernünftiger Ansatz ist erfrischend, und das kommt im Geschmack zum Ausdruck
                        sein (überraschend komplexer) Wein. Natürlich hat diese Raffinesse ihren Preis; ab Q3 2019,
                        Sein 100-Punkte-Madrona aus dem Jahr 2013 (Reifungsfähigkeit nach 50 Jahren) hatte einen Wert von etwa 700 €, einer davon
                        Napas beste und sicherste Investitionsmöglichkeiten.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vignobles d'Abreu</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Contrairement aux vignobles européens, les États-Unis ne tiennent pas autant à l'histoire familiale de la viticulture que
                        autres pays (nous vous regardons France). Ergo, si vous avez l'argent, les connaissances et
                        surtout, l'ambition de créer un Cabernet Sauvignon superlatif à partir de zéro, personne
                        va vous arrêter. David Abreu est donc quelque chose d'une rareté dans les vignobles de Napa Valley. Le troisième
                        génération pour gérer le domaine de sa famille, David a un pedigree viticole qui ferait même
                        le ????? de ???? prendre note.
                    </div>

                    <div class="howto-title2">Mère Madrona</div>
                    <div class="howto-text">
                        Gagner ses galons dans presque tous les vignobles les plus renommés de Californie (y compris Screaming
                        Eagle), David a commencé sa carrière en gérant les champs (comme son père et son grand-père avant
                        lui). Cependant, la passion de David de créer un jour son propre label est devenue trop forte, alors en
                        En 1986, il a acheté le (maintenant célèbre) vignoble Madrona de 23 acres. Madrona avait été planté six ans
                        auparavant, mais le sol pauvre exigeait une connaissance supérieure du terroir que seul Abreu pouvait
                        fournir. 1987 voit sa première sortie commerciale, un assemblage de cépages bordelais dont le cabernet
                        Sauvignon, Cabernet Franc et Merlot (Abreu a depuis planté et ajouté du Petit Verdot à la
                        mélanger). Des critiques élogieuses et des bouches à oreille positives ont suivi et en 1994, la Madrona d'Abreu avait un énorme culte
                        suivant. Il est intéressant de noter que presque tout le personnel d'origine (y compris le vigneron
                        Brad Grimes) travaillent toujours avec Abreu, et peut-être l'un des éléments clés de son succès.
                    </div>

                    <div class="howto-title2">Un Napa puissant</div>
                    <div class="howto-text">
                        La réputation de David en tant que viticulteur constamment concentré et méticuleux le précède et en tant que
                        tels que ses Thorevilos et Madrona Ranch sont parmi les vins les plus recherchés de la Napa
                        Vallée. Son approche simple et pleine de bon sens est rafraîchissante, et cela ressort de la saveur de
                        son vin (étonnamment complexe). Naturellement, une telle sophistication a un prix ; au T3 2019,
                        son Madrona 100 points 2013 (capacité de garde à 50 ans) était valorisé autour de 700 €, l'un des
                        Les options d'investissement les plus fines et les plus sûres de Napa.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Abreu Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Contrary to European vineyards, the USA does not hold family viticultural history as highly as
                        other countries (we’re looking at you France). Ergo, if you have the money, the knowledge and
                        most importantly, the ambition to create a superlative Cabernet Sauvignon from scratch, no one
                        is going to stop you. So David Abreu is something of a rarity in Napa Valley wineries. The third
                        generation to manage his family’s estate, David has a winemaking pedigree that would make even
                        the ????? of ???? take note.
                    </div>

                    <div class="howto-title2">Mother Madrona</div>
                    <div class="howto-text">
                        Earning his stripes in nearly all of California’s most renowned vineyards (including Screaming
                        Eagle), David started out his career managing the fields (like his father and grandfather before
                        him). However, David’s passion that one day he would create his own label grew too strong, so in
                        1986 he purchased the (now famous) 23-acre Madrona Vineyard. Madrona had been planted six years
                        previously, but the poor soil required superior terroir knowledge which only Abreu could
                        provide. 1987 saw his first commercial release, a blend of Bordeaux varietals including Cabernet
                        Sauvignon, Cabernet Franc and Merlot (Abreu has since planted and added Petit Verdot to the
                        mix). Rave reviews and positive word mouth followed and by 1994, Abreu’s Madrona had a huge cult
                        following. It is interesting to note that nearly all the original staff (including winemaker
                        Brad Grimes) are still working with Abreu, and perhaps one of the key elements to his success.
                    </div>

                    <div class="howto-title2">A power Napa</div>
                    <div class="howto-text">
                        David&#39;s reputation as a consistently focused, meticulous viticulturalist precedes him and as
                        such, his Thorevilos and Madrona Ranch are some of the most sought after wines in the Napa
                        Valley. His simple, common sense approach is refreshing, and this comes out in the flavour of
                        his (surprisingly complex) wine. Naturally, such sophistication comes at a price; as of Q3 2019,
                        his 100-point 2013 Madrona (ageing capacity of at 50 years) was valued at around €700, one of
                        Napa’s finest and safest investable options.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AbreuVineyards",
    head: {
        title: 'Abreu Vineyards | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wines of Abreu Vineyards, a renowned Napa Valley winery known for producing premium and highly sought-after wines. Experience the combination of traditional winemaking techniques and innovative practices that make Abreu\'s wines truly unique. Savor the depth of flavor, balance, and elegance in every glass.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Abreu Vineyards', src: '/wine-guide/usa/napa/abreu-vineyards'},
            items: [
                {report: 'Abreu Vineyards', src: '/wine-guide/usa/napa/abreu-vineyards'},
                {report: 'Caymus vineyards', src: '/wine-guide/usa/napa/caymus-vineyards'},
                {report: 'Christian Moueix - Dominus', src: '/wine-guide/usa/napa/christian-moueix-dominus'},
                {report: 'Colgin Cellars', src: '/wine-guide/usa/napa/colgin-cellars'},
                {report: 'Harlan Estates', src: '/wine-guide/usa/napa/harlan-estates'},
                {report: 'Kapcsandy Winery', src: '/wine-guide/usa/napa/kapcsandy-winery'},
                {report: 'Opus One', src: '/wine-guide/usa/napa/opus-one'},
                {report: 'Robert Mondovi Vineyards', src: '/wine-guide/usa/napa/robert-mondovi-vineyards'},
                {report: 'Scarecrow Wines', src: '/wine-guide/usa/napa/scarecrow-wines'},
                {report: 'Schrader Cellars', src: '/wine-guide/usa/napa/schrader-cellars'},
                {report: 'Screaming Eagle', src: '/wine-guide/usa/napa/screaming-eagle'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
